"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUtteranceMetaData = exports.getActionItemMetaData = exports.getAgendaItemMetaData = exports.getJmrMetaData = void 0;
const slateTypes_1 = require("../types/slateTypes");
const actionItemTypes_1 = require("../types/actionItemTypes");
const getJmrMetaData = (jmr) => {
    var _a;
    const jmrMetaData = [];
    jmrMetaData.push(createMetaElement({
        type: slateTypes_1.ObjectType.Jmr,
        field: slateTypes_1.MetaField.StartDate,
        id: jmr.id,
    }, slateTypes_1.MetaInputType.datePicker, 'today', 'date', 'no date'), createMetaElement({
        type: slateTypes_1.ObjectType.Jmr,
        field: slateTypes_1.MetaField.StartDate,
        id: jmr.id,
    }, slateTypes_1.MetaInputType.timePicker, 'schedule', 'time', 'no time'), createMetaElement({
        type: slateTypes_1.ObjectType.Jmr,
        field: slateTypes_1.MetaField.Duration,
        id: jmr.id,
    }, slateTypes_1.MetaInputType.duration, 'timer', 'duration', 'no duration'), createMetaElement({
        type: slateTypes_1.ObjectType.Jmr,
        field: slateTypes_1.MetaField.Location,
        id: jmr.id,
    }, slateTypes_1.MetaInputType.location, 'place', 'location', 'no location'), createMetaElement({
        type: slateTypes_1.ObjectType.Jmr,
        field: slateTypes_1.MetaField.Owner,
        id: jmr.id,
    }, slateTypes_1.MetaInputType.none, 'person', 'organizer'), createMetaElement({
        type: slateTypes_1.ObjectType.Jmr,
        field: slateTypes_1.MetaField.Participants,
        id: jmr.id,
    }, slateTypes_1.MetaInputType.participants, 'groups', 'participants'));
    return {
        type: slateTypes_1.CustomElementType.MetaContainer,
        artifactId: {
            type: slateTypes_1.ObjectType.Jmr,
            field: slateTypes_1.ObjectField.Meta,
            id: jmr.id,
        },
        artifactMetaData: {
            startDate: jmr.startDate,
            location: jmr.location,
            owner: jmr.owner,
            duration: jmr.duration,
            participants: ((_a = jmr.participants) === null || _a === void 0 ? void 0 : _a.length) + '',
        },
        children: jmrMetaData,
    };
};
exports.getJmrMetaData = getJmrMetaData;
const getAgendaItemMetaData = (id, options) => {
    const { agendaItem, seqNum, defaultAssignee } = options;
    const agendaItemMetaElements = [];
    agendaItemMetaElements.push(createMetaElement({
        type: slateTypes_1.ObjectType.Agenda,
        field: slateTypes_1.MetaField.Assignee,
        id: id,
    }, slateTypes_1.MetaInputType.assignee, 'person', 'assignee', 'unassigned'), createMetaElement({
        type: slateTypes_1.ObjectType.Agenda,
        field: slateTypes_1.MetaField.Duration,
        id: id,
    }, slateTypes_1.MetaInputType.duration, 'timer', 'duration', 'no duration'));
    return {
        type: slateTypes_1.CustomElementType.MetaContainer,
        artifactId: {
            type: slateTypes_1.ObjectType.Agenda,
            field: slateTypes_1.ObjectField.Meta,
            id: id,
        },
        artifactMetaData: {
            assignee: (agendaItem === null || agendaItem === void 0 ? void 0 : agendaItem.assignee) ? agendaItem === null || agendaItem === void 0 ? void 0 : agendaItem.assignee : defaultAssignee,
            seqNum: seqNum ? seqNum : 0 + '',
            duration: agendaItem === null || agendaItem === void 0 ? void 0 : agendaItem.duration,
        },
        children: agendaItemMetaElements,
    };
};
exports.getAgendaItemMetaData = getAgendaItemMetaData;
const getActionItemMetaData = (id, options) => {
    const { actionItem, defaultAssignee, isGenerated } = options;
    const actionItemMetaElements = [];
    actionItemMetaElements.push(createMetaElement({
        type: slateTypes_1.ObjectType.Action,
        field: slateTypes_1.MetaField.Assignee,
        id,
    }, slateTypes_1.MetaInputType.assignee, 'person', 'assignee', 'unassigned'), createMetaElement({
        type: slateTypes_1.ObjectType.Action,
        field: slateTypes_1.MetaField.DueDate,
        id,
    }, slateTypes_1.MetaInputType.datePicker, 'event', 'due date', 'no due date'));
    if (isGenerated === actionItemTypes_1.BooleanString.True || (actionItem === null || actionItem === void 0 ? void 0 : actionItem.isGenerated) === actionItemTypes_1.BooleanString.True)
        actionItemMetaElements.push(createMetaElement({
            type: slateTypes_1.ObjectType.Action,
            field: slateTypes_1.MetaField.Generated,
            id,
        }, slateTypes_1.MetaInputType.none, 'smart_toy', 'generated by Jambr'));
    return {
        type: slateTypes_1.CustomElementType.MetaContainer,
        artifactId: {
            type: slateTypes_1.ObjectType.Action,
            field: slateTypes_1.ObjectField.Meta,
            id: id,
        },
        artifactMetaData: {
            assignee: (actionItem === null || actionItem === void 0 ? void 0 : actionItem.assignee) ? actionItem.assignee : defaultAssignee,
            dueDate: actionItem === null || actionItem === void 0 ? void 0 : actionItem.dueDate,
            status: (actionItem === null || actionItem === void 0 ? void 0 : actionItem.status) ? actionItem.status : actionItemTypes_1.TActionStatus.NotStarted,
            isGenerated: (actionItem === null || actionItem === void 0 ? void 0 : actionItem.isGenerated)
                ? actionItem.isGenerated
                : isGenerated
                    ? isGenerated
                    : actionItemTypes_1.BooleanString.False,
        },
        children: actionItemMetaElements,
    };
};
exports.getActionItemMetaData = getActionItemMetaData;
const getUtteranceMetaData = (id, artifactMetaData) => ({
    type: slateTypes_1.CustomElementType.MetaContainer,
    artifactId: {
        type: slateTypes_1.ObjectType.Transcript,
        field: slateTypes_1.ObjectField.Meta,
        id: id,
    },
    artifactMetaData,
    children: [
        createMetaElement({
            type: slateTypes_1.ObjectType.Transcript,
            field: slateTypes_1.MetaField.StartDate,
            id: id,
        }, slateTypes_1.MetaInputType.timePicker, 'schedule', 'start time'),
    ],
});
exports.getUtteranceMetaData = getUtteranceMetaData;
const createMetaElement = (artifactMetaId, inputType, icon, tooltip, placeholder) => ({
    type: slateTypes_1.CustomElementType.Meta,
    artifactMetaId,
    inputType,
    icon,
    tooltip,
    placeholder,
    children: [{ text: '' }],
});
